import withClassroomContentIdChange from './withClassroomContentIdChange';

export default withClassroomContentIdChange;
